import { useState, useEffect, useContext } from 'react';
import { DataContext } from '../contexto/ContextoDatos';

export const useGoogleReviews = (apiKey) => {
  const { testimonials: fallbackTestimonials } = useContext(DataContext);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Si no hay API key, usamos los de prueba inmediatamente
    if (!apiKey) {
      setReviews(fallbackTestimonials || []);
      setLoading(false);
      return;
    }

    const loadGoogleMapsScript = () => {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    const fetchReviews = async () => {
      try {
        setLoading(true);
        await loadGoogleMapsScript();

        const dummyElement = document.createElement('div');
        const service = new window.google.maps.places.PlacesService(dummyElement);

        // 1. Encontrar el Place ID buscando SEIMA Guatemala
        const requestFind = {
          query: 'SEIMA Blvd. los Proceres 19-08 Ciudad de Guatemala',
          fields: ['place_id'],
        };

        service.findPlaceFromQuery(requestFind, (results, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && results && results.length > 0) {
            const placeId = results[0].place_id;

            // 2. Obtener los detalles del lugar (incluyendo reseñas)
            const requestDetails = {
              placeId: placeId,
              fields: ['reviews'],
              language: 'es'
            };

            service.getDetails(requestDetails, (place, statusDetail) => {
              if (statusDetail === window.google.maps.places.PlacesServiceStatus.OK && place.reviews) {
                // Mapear el formato de Google al formato de nuestras tarjetas
                const formattedReviews = place.reviews.map((r, i) => ({
                  id: i,
                  name: r.author_name,
                  role: "Cliente verificado en Google",
                  company: "",
                  content: r.text,
                  rating: r.rating,
                  image: r.profile_photo_url
                }));
                // Filtrar las que no tienen texto y ordenarlas por mayor rating
                const validReviews = formattedReviews
                  .sort((a, b) => {
                    // Dar prioridad a las reseñas que sí tienen texto
                    const aHasText = a.content && a.content.trim().length > 0;
                    const bHasText = b.content && b.content.trim().length > 0;
                    if (aHasText && !bHasText) return -1;
                    if (!aHasText && bHasText) return 1;
                    // Si ambas tienen o no tienen texto, ordenar por rating
                    return b.rating - a.rating;
                  });
                
                if (validReviews.length > 0) {
                  setReviews(validReviews);
                } else {
                  setReviews(fallbackTestimonials || []);
                }
              } else {
                setReviews(fallbackTestimonials || []);
              }
              setLoading(false);
            });
          } else {
            console.warn('No se pudo encontrar el Place ID de SEIMA. Usando testimonios de prueba.');
            setReviews(fallbackTestimonials || []);
            setLoading(false);
          }
        });

      } catch (err) {
        console.error('Error cargando Google Maps API:', err);
        setError(err);
        setReviews(fallbackTestimonials || []);
        setLoading(false);
      }
    };

    fetchReviews();

  }, [apiKey, fallbackTestimonials]);

  return { reviews, loading, error };
};
